export default {
  threadsForDisplay: (state) => {
    return state.threads.filter((t) => {
      // Filter out deleted threads with no replies, unless user can restore the thread
      return !t.isDeleted || state.canDelete || t.replies.length > 0
    })
  },

  threadsAvailableForLoading: (state) => {
    return state.pagination.currentPage < state.pagination.totalPages
  }
}
